import React from 'react';
import { Box, styled } from '@mui/material';
import { useLocation } from 'react-router-dom';
import ClientContainer from '../../components/SingleClient/SingleClient';
import CoachPageLayout from '../../components/CoachPageLayout/CoachPageLayout';

interface StyledBoxProps {
  isProgressTab: boolean;
}

const StyledBox = styled(Box)<StyledBoxProps>(({ isProgressTab }) => ({
  height: isProgressTab ? '100%' : '100%',
  width: '100%',
  padding: '24px 0 0 0',
  background: 'linear-gradient(163deg, #FFF 10.13%, #FFF4F0 89.18%) !important',
}));

const SingleClient = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isProgressTab = searchParams.get('tab') === 'progress';

  return (
    <CoachPageLayout>
      <StyledBox isProgressTab={isProgressTab}>
        <ClientContainer />
      </StyledBox>
    </CoachPageLayout>
  );
};

export default SingleClient;
